import { render } from "./MultilineText.vue?vue&type=template&id=7f487664"
import script from "./MultilineText.vue?vue&type=script&lang=js"
export * from "./MultilineText.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Shared/MultilineText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f487664"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f487664', __exports__)) {
    console.log('reload')
    api.reload('7f487664', __exports__)
  }
  
  module.hot.accept("./MultilineText.vue?vue&type=template&id=7f487664", () => {
    console.log('re-render')
    api.rerender('7f487664', render)
  })

}


export default __exports__